import { Pipe, PipeTransform } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { Product } from '../../interfaces/product.interface';
import { PlanSortByAttributeStateStructure } from '../../plan-sort-by-attribute/configs/interfaces/plan-sort-by-attribute.state.interface';
import { PLAN_SORT_BY_ATTRIBUTE } from '../../plan-sort-by-attribute/configs/plan-sort-by-attribute.reducer';

@Pipe({
    name: 'planDataSorter',
    pure: false,
    standalone: false
})
export class PlanDataSorterPipe implements PipeTransform {

  sorts = (() => {
    return {
      premium: this._premiumSort,
      planName: this._planNameSort,
      deductible: this._deductibleSort
    }
  })();

  constructor(
    private reducerUtilityService: ReducerUtilityService
  ) { }

  transform(products: Product<PlanAttributes, SummaryView>[], ...args: unknown[]): Product<PlanAttributes, SummaryView>[] {
    const activeSortMethod: string
      = (this.reducerUtilityService.getState(PLAN_SORT_BY_ATTRIBUTE) as PlanSortByAttributeStateStructure).activeSortMethod;

    if (activeSortMethod) {
      return products.sort((product1, product2) => this.filterStrategy(activeSortMethod)(product1, product2));
    } else {
      return products;
    }
  }

  private filterStrategy(activeSortMethod: string): (
    a: Product<PlanAttributes, SummaryView>,
    b: Product<PlanAttributes, SummaryView>
  ) => number {
    switch (activeSortMethod) {
      case 'premium-low-to-high': return this.sorts.premium(true);
      case 'premium-high-to-low': return this.sorts.premium(false);
      case 'plan-name': return this.sorts.planName();
      case 'deductible-low-to-high': return this.sorts.deductible(true);
      case 'deductible-high-to-low': return this.sorts.deductible(false);
    }
  }

  private _premiumSort(reverse: boolean) {
    return (
      a: Product<PlanAttributes, SummaryView>,
      b: Product<PlanAttributes, SummaryView>
    ) => {
      if (a.price < b.price) {
        return reverse ? 1 : -1;
      } else if (a.price > b.price) {
        return reverse ? 1 : -1;
      } else {
        return 0;
      }
    };
  }
  private _planNameSort() {
    return (
      a: Product<PlanAttributes, SummaryView>,
      b: Product<PlanAttributes, SummaryView>
    ) => {
      if (a.productName < b.productName) {
        return -1;
      } else if (a.productName > b.productName) {
        return 1;
      } else {
        return 0;
      }
    };
  }
  private _deductibleSort(reverse: boolean) {
    return (
      a: Product<PlanAttributes, SummaryView>,
      b: Product<PlanAttributes, SummaryView>
    ) => {
      const isDeductibleBenefit = (benefit: { key: string }) => {
        return (
          benefit?.key?.toUpperCase() === "Annual Deductible Per Person".toUpperCase() ||
          benefit?.key?.toUpperCase() === "Deductible".toUpperCase()
        );
      }

      let deductibleA = 0;
      let deductibleB = 0;
      for (const obj of a.summaryView.benefits) {
        /**
         * if the value is alphanumeric "$1000euro-2000euro" for example
         * strip everything after the initial number and sort on that: 1000
         */
        if (isDeductibleBenefit(obj)) {
          deductibleA = parseInt(obj['value'].replace(/[$,a-z]+/gi, ''), 10);
        }
      }
      for (const obj of b.summaryView.benefits) {
        if (isDeductibleBenefit(obj)) {
          deductibleB = parseInt(obj['value'].replace(/[$,a-z]+/gi, ''), 10);
        }
      }
      if (reverse) {
        return deductibleA - deductibleB;
      } else {
        return deductibleB - deductibleA;
      }

    };
  }

}
